import { render, staticRenderFns } from "./instrumentsNew.vue?vue&type=template&id=b4df5304&scoped=true"
import script from "./instrumentsNew.vue?vue&type=script&lang=js"
export * from "./instrumentsNew.vue?vue&type=script&lang=js"
import style0 from "./instrumentsNew.vue?vue&type=style&index=0&id=b4df5304&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4df5304",
  null
  
)

export default component.exports